import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {MaterialWithRecipes} from '../types'

export const MaterialWithRecipesQueryKey = 'materialWithRecipes'

const materialWithRecipesQueryOptions = (plantCode: string, materialId: number | undefined) => ({
  queryKey: [MaterialWithRecipesQueryKey, plantCode, materialId] as const,
  queryFn: async ({signal}: {signal?: AbortSignal}) => {
    if (materialId === undefined) return undefined
    const response = await ApiClient.axiosInstance.get<MaterialWithRecipes>(
      `/plants/${plantCode}/materials/${materialId}`,
      {signal}
    )
    return response.data
  }
})

type Params<TReturn = MaterialWithRecipes | undefined> = {
  plantCode: string
  materialId: number | undefined
  options?: Omit<
    UseQueryOptions<MaterialWithRecipes | undefined, AxiosError, TReturn>,
    'queryKey' | 'queryFn'
  >
}

export const useMaterialWithRecipes = <TReturn = MaterialWithRecipes | undefined>({
  plantCode,
  materialId,
  options
}: Params<TReturn>) =>
  useQuery<MaterialWithRecipes | undefined, AxiosError, TReturn>({
    ...materialWithRecipesQueryOptions(plantCode, materialId),
    ...options
  })
